import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BlankLayoutComponent } from './blankTemp/blank-layout/blank-layout.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { AlumniQueriesComponent } from './modules/auth/alumni-queries/alumni-queries.component';
import { JobDetailComponent } from './modules/auth/job-detail/job-detail.component';
import { JobsComponent } from './modules/auth/jobs/jobs.component';
import { AuthGuard } from './service/guards/auth/auth.guard';
import { ChildRouterGuard } from './service/guards/child-router/child-router.guard';
import { ItemListComponent } from './shared/components/item-list/item-list.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { QrCodeStatusComponent } from './shared/components/qr-code-status/qr-code-status.component';
import { InternalJobs2Component } from './modules/auth/internal-jobs2/internal-jobs2.component';
import { JobDetailsComponent } from './modules/auth/job-details/job-details.component';


const routes: Routes = [
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: '',
        redirectTo: 'auth',
        pathMatch: 'full',
      },
      {
        path: 'auth',
        component: BlankComponent,
        loadChildren: () =>
          import('./modules/auth/auth.module').then((m) => m.AuthModule),
      },
      {
        path: 'qr-code-status/:id',
        component: QrCodeStatusComponent,
      },
      {
        path: 'item-list/:scopeId/:seatId',
        component: ItemListComponent,
      },
      {
        path: 'jobs',
        component: JobsComponent,
      },
      {
        path: 'internal-jobs2',
        component: InternalJobs2Component,
      },
      {
        path: 'jobdetails/:id',
        component:JobDetailsComponent
      },

      {
        path: 'alumni-queries',
        component: AlumniQueriesComponent,
      },
      {
        path: 'jobs/:id',
        component: JobDetailComponent,
      },
      {
        path: 'jobs/:id/:source',
        component: JobDetailComponent,
      },
    ],
  }, // end of first component blank
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dasboard/dasboard.module').then(
            (m) => m.DasboardModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'setups',
        loadChildren: () =>
          import('./modules/setups/setups.module').then((m) => m.SetupsModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard]
      },
      {
        path: 'talent',
        loadChildren: () =>
          import('./modules/talent/talent.module').then((m) => m.TalentModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard]
      },
      {
        path: 'employee',
        loadChildren: () =>
          import('./modules/employee/employee.module').then(
            (m) => m.EmployeeModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'payroll',
        loadChildren: () =>
          import('./modules/payroll/payroll.module').then(
            (m) => m.PayrollModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'queries',
        loadChildren: () =>
          import('./modules/query/query.module').then((m) => m.QueryModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'assets',
        loadChildren: () =>
          import('./modules/assets/assets.module').then((m) => m.AssetsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'leaves',
        loadChildren: () =>
          import('./modules/leave/leave.module').then((m) => m.LeaveModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'attendance',
        loadChildren: () =>
          import('./modules/attendance/attendance.module').then(
            (m) => m.AttendanceModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'l&d',
        loadChildren: () =>
          import(
            './modules/learning-development/learning-development.module'
          ).then((m) => m.LearningDevelopmentModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'complaince',
        loadChildren: () =>
          import('./modules/compliance/compliance.module').then(
            (m) => m.ComplianceModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'policies',
        loadChildren: () =>
          import('./modules/hr-policy/hr-policy.module').then(
            (m) => m.HrPolicyModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./modules/mis-reports/mis-reports.module').then(
            (m) => m.MisReportsModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'experience',
        loadChildren: () =>
          import('./modules/kudos/kudos.module').then((m) => m.KudosModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'appraisal',
        loadChildren: () =>
          import('./modules/epa/epa.module').then((m) => m.EpaModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'expenses',
        loadChildren: () =>
          import('./modules/expense/expense.module').then(
            (m) => m.ExpenseModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'reports-dashboard',
        loadChildren: () =>
          import('./modules/reports-dashboard/reports-dashboard.module').then(
            (m) => m.ReportsDashboardModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'surveys',
        loadChildren: () =>
          import('./modules/survey/survey.module').then((m) => m.SurveyModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'sms',
        loadChildren: () =>
          import('./modules/communication/communication.module').then(
            (m) => m.CommunicationModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'quick-links',
        loadChildren: () =>
          import('./modules/quick-link-routes/quick-link-routes.module').then(
            (m) => m.QuickLinkRoutesModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'stop-hunger',
        loadChildren: () =>
          import('./modules/stop-hunger/stop-hunger.module').then(
            (m) => m.StopHungerModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'vendors',
        loadChildren: () =>
          import('./modules/vendor-management/vendor-management.module').then(
            (m) => m.VendorManagementModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./modules/finance-management/finance-management.module').then(
            (m) => m.FinanceManagementModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'covid19',
        loadChildren: () =>
          import('./modules/covid-19/covid-19.module').then(
            (m) => m.Covid19Module
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'timesheet',
        loadChildren: () =>
          import('./modules/time-sheets/time-sheets.module').then(
            (m) => m.TimeSheetsModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'energy-resource',
        loadChildren: () =>
          import('./modules/energy-resource/energy-resource.module').then(
            (m) => m.EnergyResourceModule
          ),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'hse',
        loadChildren: () =>
          import('./modules/hse/hse.module').then((m) => m.HseModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'property',
        loadChildren: () =>
          import(
            './modules/property-management/property-management.module'
          ).then((m) => m.PropertyManagementModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'bgv-mngmnt',
        loadChildren: () =>
          import('./modules/bgv-management/bgv-management.module').then(
            (m) => m.BgvManagementModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'blank-layout',
        component: BlankLayoutComponent,
      },
      {
        path: 'cmms',
        loadChildren: () =>
          import('./modules/cmms/cmms.module').then((m) => m.CmmsModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'gr-reporting',
        loadChildren: () =>
          import('./modules/gr-module/gr-module.module').then(
            (m) => m.GrModuleModule
          ),
        canActivate: [AuthGuard],
      },
       {
        path: 'crms',
        loadChildren: () =>
          import('./modules/crm/crm.module').then((m) => m.CrmModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'alumni',
        loadChildren: () => import('./modules/alumini-portal/alumini-portal.module').then(m => m.AluminiPortalModule)
      },
      {
        path: 'cross-selling',
        loadChildren: () => import('./modules/cross-selling/cross-selling.module').then(m => m.CrossSellingModule),
        canActivate: [AuthGuard],
        canActivateChild: [ChildRouterGuard],
      },
      {
        path: 'meal',
        loadChildren: () =>
          import('./modules/meal-management/meal-management.module').then(
            (m) => m.MealManagementModule
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
